import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Header from './components/Header';
import Hero from './components/Hero';
import Catalog from './components/Catalog';
import Calculator from './components/Calculator';
import About from './components/About';
import Partnership from './components/Partnership';
import Reviews from './components/Reviews';
import Contacts from './components/Contacts';
import Footer from './components/Footer';
import ChatBot from './components/UI/ChatBot';
import PromoPopup from './components/UI/PromoPopup';
import ScrollToTop from './components/UI/ScrollToTop';

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Main = styled.main`
  flex: 1;
`;

function App() {
  const [showPromo, setShowPromo] = useState(false);
  
  useEffect(() => {
    // Показываем промо попап через 10 секунд
    const timer = setTimeout(() => {
      setShowPromo(true);
    }, 10000);
    
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <AppContainer>
      <Header />
      <Main>
        <Hero />
        <Catalog />
        <Calculator />
        <About />
        <Partnership />
        <Reviews />
        <Contacts />
      </Main>
      <Footer />
      <ChatBot />
      <ScrollToTop />
      {showPromo && <PromoPopup onClose={() => setShowPromo(false)} />}
    </AppContainer>
  );
}

export default App; 